module.exports = __webpack_public_path__ + "img/prop-tv-1-left.e39ad127.png";